import * as XLSX from "xlsx"
import { getStatusTexFromValue } from "./statusMap"
import { formatDate } from "./formatDate"

export const exportToExcel = (data, fileName = "relatorio") => {
  const exportData = data.map(process => ({
    "Número CNJ": process.NumeroCNJ,
    Empresa: process.Lead?.ReuRazaoSocial || "-",
    "Data Publicação": process.Publicacoes[0]?.DataProcessamento || "-",
    "Data Análise": process.Lead?.DataCadastro || "-",
    "Data Monitoramento": process.Lead?.DataEnvio || "-",
    Status:
      getStatusTexFromValue(Number(process.Publicacoes[0]?.Status)) || "-",
    "Última Movimentação":
      formatDate(process.Andamentos[0].dataAndamento) || "-",
    "Data Encerramento": process.Lead?.DataEncerramento || "-",
  }))

  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Processos")

  XLSX.writeFile(
    workbook,
    `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`
  )
}
